import { Button, Grid, LinearProgress, Typography } from '@mui/material';
import { ProductSelection } from '../../../constants/constant';
import useProductDrawer from './product-drawer.hook';
import {
  toggleDrawerChildItemOpportunity,
  toggleDrawerParentItemOpportunity
} from '../../store/planner-slice';
import ProductDetailsBox from './product-details-box';

/**
 * Drawer content for PPG view.
 */
export default function PPGDrawer() {
  const {
    childDetailsExpandableMap,
    handleAddComment,
    isLoading,
    product,
    productId,
    appDispatch,
    collapseAll,
    toggleExpansion,
    handleDeleteComment,
    handleUpdateComment,
    plannerAccessConfig
  } = useProductDrawer({ toggle: ProductSelection.ppg });

  if (isLoading || !product.parent_details) {
    return <LinearProgress />;
  }
  return (
    <Grid container>
      <Grid item xs={12}>
        <ProductDetailsBox
          isPPGBox
          isExpandable={false}
          opportunities={product.opportunities.ppg}
          productDetails={product.parent_details}
          isOpen={false}
          // eslint-disable-next-line @typescript-eslint/no-empty-function
          toggleExpandableState={null}
          isOpportunitiesSelectionDisabled={
            !plannerAccessConfig?.change_own_opportunity
          }
          onCommentDelete={handleDeleteComment}
          onCommentUpdate={handleUpdateComment}
          onCommentAdd={(comment) =>
            handleAddComment(comment, productId, undefined, null)
          }
          onOpportunitySelection={(
            isOpportunityChecked,
            selectedOpportunities,
            changedOpportunity
          ) => {
            appDispatch(
              toggleDrawerParentItemOpportunity({
                changedOpportunity,
                isOpportunityChecked,
                selectedOpportunities
              })
            );
          }}
        />
      </Grid>
      <Grid
        container
        justifyContent='space-between'
        alignItems='center'
        item
        xs={12}
        my={2}
      >
        {product.child_details.length ? (
          <>
            <Grid item xs='auto'>
              <Typography color='#8080CF' fontWeight={700} fontSize='14px'>
                List of SKUs - {product.child_details?.length} SKUs
              </Typography>
            </Grid>
            <Grid item xs='auto' onClick={collapseAll}>
              <Button variant='outlined'>Collapse All</Button>
            </Grid>
          </>
        ) : null}
      </Grid>
      {product.child_details?.map((skuDetails, indexOfChild) => (
        <Grid item xs={12} mb={1} key={skuDetails.name}>
          <ProductDetailsBox
            isPPGBox={false}
            isExpandable
            isOpen={childDetailsExpandableMap[indexOfChild]}
            opportunities={product.opportunities.sku}
            isOpportunitiesSelectionDisabled={
              !plannerAccessConfig?.change_own_opportunity
            }
            productDetails={skuDetails}
            onCommentAdd={(comment) =>
              handleAddComment(comment, productId, skuDetails.id, indexOfChild)
            }
            onCommentDelete={(commentId) =>
              handleDeleteComment(commentId, indexOfChild)
            }
            onCommentUpdate={(commentId, updatedComment) =>
              handleUpdateComment(commentId, updatedComment, indexOfChild)
            }
            toggleExpandableState={() => {
              toggleExpansion(indexOfChild);
            }}
            onOpportunitySelection={(
              isOpportunityChecked,
              selectedOpportunities,
              changedOpportunity
            ) => {
              appDispatch(
                toggleDrawerChildItemOpportunity({
                  changedOpportunity,
                  isOpportunityChecked,
                  selectedOpportunities,
                  indexOfChild
                })
              );
            }}
          />
        </Grid>
      ))}
    </Grid>
  );
}
